export default __webpack_public_path__ + "static/media/master-plan-1.c307e4d2.jpg";